import React from 'react';
import styled from 'styled-components';

const TagContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 2rem;
	padding: 0.5rem;
	margin: 0.1rem;
	border-radius: 16px;
	border: none;
	font-size: 0.9rem;
	color: ${({ theme }) => theme.DCBLOX_Gray};
	background-color: ${({ theme }) => theme.white};
	text-transform: capitalize;
`;

const closeButtonStyles = {
	marginLeft: '8px',
	cursor: 'pointer',
	fontWeight: 'bold',
};

const Tag = ({ tag, handleRemoveTag }) => {
	return (
		<TagContainer className='tag-container'>
			<span>{tag}</span>
			<span style={closeButtonStyles} onClick={() => handleRemoveTag(tag)}>
				x
			</span>
		</TagContainer>
	);
};

export default Tag;
